import React from "react";

// Read-only radio/checkbox presentation for a recorded answer: the selected
// option is visually distinct, unselected options stay visible so the reader
// sees the field's full choice set (never a grey text box).
export const RadioPill = ({ label, selected, square = false }) => {
  const indicator = selected ? (
    <span
      className={`inline-flex h-4 w-4 items-center justify-center border-2 border-indigo-600 ${
        square ? "rounded" : "rounded-full"
      }`}
    >
      <span className={`h-1.5 w-1.5 bg-indigo-600 ${square ? "rounded-sm" : "rounded-full"}`} />
    </span>
  ) : (
    <span
      className={`inline-flex h-4 w-4 border-2 border-gray-300 ${square ? "rounded" : "rounded-full"}`}
    />
  );

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm ${
        selected
          ? "border-indigo-200 bg-indigo-50 text-indigo-700"
          : "border-gray-200 bg-white text-gray-700"
      }`}
    >
      {indicator}
      <span>{label}</span>
    </span>
  );
};

const normalizeToken = (v) =>
  String(v ?? "")
    .trim()
    .toLowerCase()
    .replace(/^n\/a$/, "na");

// values: string | string[] — a string matches one option; an array (or a
// semicolon-joined string upstream) marks every contained option selected.
const AnswerRadioGroup = ({ options, values, multi = false }) => {
  const opts = Array.isArray(options) && options.length > 0 ? options : ["Yes", "No"];
  const selectedSet = new Set(
    (Array.isArray(values) ? values : [values])
      .filter((v) => v !== null && v !== undefined && String(v).trim() !== "")
      .map(normalizeToken)
  );

  return (
    <div className="flex flex-wrap gap-2">
      {opts.map((opt) => (
        <RadioPill
          key={opt}
          label={opt}
          square={multi}
          selected={selectedSet.has(normalizeToken(opt))}
        />
      ))}
    </div>
  );
};

export default AnswerRadioGroup;
